export enum KeycloakClients {
  apiKeyManagement = 'api-key-management',
}
export interface KeycloakTokenResponse {
  access_token: string;
  refresh_token: string;
}
